import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Container, Typography, Box, LinearProgress } from '@mui/material';

const MovieContainer = styled(Container)(({ theme }) => ({
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(4),
  backgroundColor: '#1a1a1a',
  color: 'white',
}));

const MovieCard = styled(Box)(({ theme }) => ({
  backgroundColor: '#262626',
  borderRadius: '10px',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
  padding: theme.spacing(2),
  margin: theme.spacing(2),
  textAlign: 'center',
  width: '300px', // Match the width in the screenshot
}));

const MoviePoster = styled('img')({
  width: '100%',
  height: '450px',
  objectFit: 'cover',
  borderRadius: '10px',
  marginBottom: '16px', // Use a fixed value instead of theme.spacing(1)
});

function MoviesPage() {
  const [searchTerm, setSearchTerm] = useState('');

  // Static movie data
  const staticMovies = [
    {
      id: 1,
      name: 'Stree 2: Sarkate Ka Aatank',
      genre: 'Horror',
      image: 'https://cinevest.vercel.app/_next/image?url=https%3A%2F%2Ffirebasestorage.googleapis.com%2Fv0%2Fb%2Fgaadhaar-7ff3f.appspot.com%2Fo%2Fposters%252F1728662935702_MV5BZTEyYzVjYjEtNWYzZi00NWRhLTgyZjUtNDlkZjBiNWIxYTEwXkEyXkFqcGc%2540._V1_.jpg%3Falt%3Dmedia%26token%3Db86c445e-6b3b-43ba-b5b9-7e3a19b8c003&w=384&q=75',
      currentFunding: 285000, // ₹28,50,000
      targetFunding: 5000000, // ₹50,00,000
    },
    {
      id: 2,
      name: 'Deadpool & Wolverine',
      genre: 'Sci-Fi',
      image: 'https://cinevest.vercel.app/_next/image?url=https%3A%2F%2Ffirebasestorage.googleapis.com%2Fv0%2Fb%2Fgaadhaar-7ff3f.appspot.com%2Fo%2Fposters%252F1728725362909_medium-joker-movie-poster-for-room-office-13-inch-x-19-inch-original-imafk9kg4hczamuz.webp%3Falt%3Dmedia%26token%3D38f922ca-4d0e-4c84-b131-3e021e09dbd6&w=384&q=75',
      currentFunding: 10000, // ₹10,00,000
      targetFunding: 10000000, // ₹10,00,000
    },
    {
      id: 3,
      name: 'Joker: Folie à Deux',
      genre: 'Action',
      image: 'https://cinevest.vercel.app/_next/image?url=https%3A%2F%2Ffirebasestorage.googleapis.com%2Fv0%2Fb%2Fgaadhaar-7ff3f.appspot.com%2Fo%2Fposters%252F1728663027256_deadpoolandwolverine_lob_crd_03.jpg%3Falt%3Dmedia%26token%3D4f5e0200-d588-4fed-bd1c-711fbed95b12&w=384&q=75',
      currentFunding: 10000, // ₹10,00,000
      targetFunding: 30000000, // ₹30,00,000
    },
  ];

  // Filter movies based on search term (though search isn’t shown in the screenshot, keeping it for consistency)
  const filteredMovies = staticMovies.filter((movie) =>
    movie.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Calculate progress percentage
  const calculateProgress = (current, target) => {
    if (target === 0) return 0;
    return Math.min((current / target) * 100, 100); // Cap at 100%
  };

  // Render movie cards
  const renderMovies = (movies) => (
    <Box display="flex" flexWrap="wrap" justifyContent="center">
      {movies.map((movie) => (
        <MovieCard key={movie.id}>
          <Link to={`/movie/${movie.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
            <MoviePoster src={movie.image} alt={movie.name} />
            <Typography variant="body2">{movie.name}</Typography>
            <Typography variant="caption" >
              {movie.genre} {movie.releaseDate}
            </Typography>
            <Typography variant="body2" gutterBottom>
              ₹{movie.currentFunding.toLocaleString()} / ₹{movie.targetFunding.toLocaleString()}
            </Typography>
            <LinearProgress
              variant="determinate"
              value={calculateProgress(movie.currentFunding, movie.targetFunding)}
              sx={{
                width: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                '& .MuiLinearProgress-bar': {
                  backgroundColor: '#7d1aed', // Match the purple theme
                },
              }}
            />
          </Link>
        </MovieCard>
      ))}
    </Box>
  );
  
  return (
    <MovieContainer maxWidth="lg">
      <Typography variant="h4" component="h2" gutterBottom>
        All Movies
      </Typography>
      {renderMovies(filteredMovies)}
    </MovieContainer>
  );
}

export default MoviesPage;